import { Button } from "../../../../core/components/atoms/Button";
import { Typography } from "../../../../core/components/molecules/Typography";
import { Modal } from "../../../../core/components/templates/Modal";

interface IModalOnChange {
  onCancel: () => void;
  action: () => void;
  isOpen: boolean;
  onClose: () => void;
}

export default function ModalOnChange({ onCancel, action, isOpen, onClose }: IModalOnChange) {

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      position="center"
      className="p-0 w-2/5"
    >
      <div className="flex flex-col gap-xl">
        <Typography>
          Se você alterar o tipo de redação, você perderá o conteúdo que ja foi iniciado. 
          Tem certeza de que deseja fazer essa alteração?
        </Typography>
        <div className="flex f1lex-row items-center justify-end gap-sm">
          <Button variant="text" onClick={() => onCancel()}>
            Cancelar
          </Button>
          <Button variant="text" onClick={() => action()}>
            Alterar tipo de envio
          </Button>
        </div>
      </div>
    </Modal>
  )
}